import React from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {
  ScenarioMapNumber,
  useMapContextStore,
} from "../../../../context/MapContext";
import { SCENARIOS } from "../../../../constants/scenarios";
import { useTheme } from "@mui/material";
import { useWindowDimensions } from "../../../../utils/WindowDimensions";

export const ScenarioSelector: React.FC<{ dropdown?: boolean }> = ({
  dropdown,
}) => {
  const { scenario, setScenario } = useMapContextStore((store) => store);
  const theme = useTheme();
  const { width } = useWindowDimensions() || {};

  return (
    <FormControl>
      <FormLabel
        id="demo-radio-buttons-group-label"
        sx={{
          fontStyle: "italic",
          fontSize: { xs: ".75rem", md: "1rem" },
          color: theme.palette.primary.main,
        }}
      >
        Boundaries
      </FormLabel>
      <ToggleButtonGroup
        orientation={width > 900 || dropdown ? "horizontal" : "vertical"}
        onChange={(e, value) => setScenario(value)}
        exclusive
        sx={{ backgroundColor: "white", width: "fit-content" }}
      >
        {SCENARIOS.map((scenarioIteration, i) => (
          <ToggleButton
            value={scenarioIteration}
            key={i}
            size="small"
            sx={{
              width: dropdown ? "auto" : "8rem",
              p: { xs: ".25rem", md: ".5rem" },
              "&.Mui-selected, &.Mui-selected:hover": {
                color: "white",
                backgroundColor: theme.palette.primary.main,
              },
            }}
            selected={scenarioIteration === scenario}
          >
            {ScenarioMapNumber[scenarioIteration]}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FormControl>
  );
};
